export const BLUE_100 = '#0072BB';

export const ACCENT_GRAY_100 = '#f5f5f5';
export const ACCENT_GRAY_200 = '#323E4C';
export const ACCENT_GRAY_300 = '#2D3743';
export const ACCENT_GRAY_400 = '#29313C';
export const ACCENT_GRAY_500 = '#232C35';
